import { InjectionToken } from '@angular/core';

/** Injection token for passing data to a modal component. Drop-in replacement for MAT_DIALOG_DATA. */
export const MODAL_DATA = new InjectionToken<any>('MODAL_DATA');

/** Configuration for opening a modal. Compatible subset of MatDialogConfig. */
export interface ModalConfig<D = any> {
  /** Data to inject into the modal component via MODAL_DATA. */
  data?: D;
  /** CSS class(es) applied to the modal host element. */
  panelClass?: string | string[];
  /** Whether clicking the backdrop should close the modal. */
  disableClose?: boolean;
  /** Whether to auto-focus the first focusable element. */
  autoFocus?: boolean;
  /** Whether the modal has a backdrop. Default true. */
  hasBackdrop?: boolean;
}
